<virtual-scroller
  #scroll
  [items]="virtualItems"
  [enableUnequalChildrenSizes]="true"
  [bufferAmount]="3"
  [parentScroll]="el">
  @for (virtualItem of scroll.viewPortItems; track trackByFn($index, virtualItem)) {
    <div #container>
      <app-hub-item
        [item]="virtualItem.item"
        [disablePublisherLink]="disablePublisherLink"
        (selectStudent)="selectStudent.emit($event)"
        (selectChannel)="selectChannel.emit($event)"
        (selectItem)="selectItem.emit($event)"
        (selectAttendanceAlerts)="selectAttendanceAlerts.emit($event)"
        (selectPaymentRequests)="selectPaymentRequests.emit($event)"
        (toggleItemDone)="toggleItemDone.emit($event)"
        (inViewport)="itemInView(virtualItem.item)"
        (openAttachment)="openAttachment.emit($event)"
        (shareItem)="shareItem.emit($event)"
        (translateItem)="translateItem.emit($event)"
        (showOriginalItem)="showOriginalItem.emit($event)"
        (getThumb)="getThumb.emit($event)"
        (showPayment)="showPayment.emit($event)"
        (showSlip)="showSlip.emit($event)"
        (reactWith)="reactWith.emit($event)">
      </app-hub-item>
    </div>
  }

  <div class="lastItemCont">
    @if (parentLoading) {
      <div class="loadingSpinnerCont ion-text-center">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    } @else {
      @if (showSearchMore && scroll.viewPortItems?.length > 0) {
        <a class="searchMoreLink" (click)="emitServerSearch()"
          >Search for more</a
          >
        }
        @if (!showSearchMore && lastItemReached) {
          <ion-icon src="/assets/icon/parent-hub-logo-dark.svg"></ion-icon>
        }
      }

    </div>
  </virtual-scroller>
